import { Button } from '@foam/buoy/src/components/Button/Button';
import { useRouter } from 'next/router';
import { SupportedPlatforms } from '~/constants/platforms';

import { MockMetrics } from './MockMetrics';

interface Props {
  platform: SupportedPlatforms;
  hasError?: boolean;
  isManager: boolean;
  isBuilder?: boolean;
  isSTMPredicted?: boolean;
  messageToShow?: string;
}
export const EmptyState: React.FC<Props> = ({
  platform,
  isManager,
  hasError = false,
  isBuilder = false,
  isSTMPredicted = false,
  messageToShow = 'Detailed Talent & Channel metrics are not currently available for this Talent. Please try again later.',
}) => {
  const router = useRouter();
  const slug = router.query.creatorSlug as string;

  const navigateToConnections = () => {
    router.push(`/t/${slug}/platform-connections`);
  };

  const getHeadingMessage = () => {
    if (hasError || platform === 'snapchat') return messageToShow;
    if (isSTMPredicted)
      return 'Channel metric estimates are unavailable for this Talent. Invite them to connect to view their verified metrics.';
    return 'Access detailed metrics directly from platform APIs by asking this Talent to connect their social accounts.';
  };

  return (
    <div className="relative">
      <div className="pointer-events-none select-none opacity-30">
        <MockMetrics platform={platform} isBuilder={isBuilder} />
      </div>
      <div className="absolute inset-0 z-20 flex items-end justify-center p-4">
        <div className="flex max-w-[600px] flex-col items-center gap-4 text-center">
          <h3
            className="text-20 font-500"
            style={{
              textShadow: '0 0 10px white, 0 0 20px white, 0 0 30px white',
            }}
          >
            {getHeadingMessage()}
          </h3>
          {!hasError && isManager && platform !== 'snapchat' && (
            <Button size="lg" onClick={navigateToConnections}>
              Connect
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
